module.exports = __webpack_public_path__ + "img/important.gif"


/*****************
 ** WEBPACK FOOTER
 ** ./jaguar/js/jquery/jquery_alert/images/important.gif
 ** module id = 132
 ** module chunks = 0 1
 **/